<template>
  <el-dialog
    :title="'设置产品绑定'"
    :visible="true"
    width="800px"
    :before-close="closeForm"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      :inline="true"
      class="demo-form-inline"
    >
      <template>
        <!-- <el-form-item label="门店" prop="shopid">
          <el-cascader
            v-model="ruleForm.shopid"
            :options="options"
            @change="handleChange"
            clearable
            style="width:640px;"
          ></el-cascader>
        </el-form-item> -->

        <agentVendorShop
          @select="selectHandler"
          :initData="selectedAvs"
          @init="initHandler"
        />

        <el-form-item label="机器型号" prop="machineModel">
          <form ref="machine_select">
            <el-select
              v-model="ruleForm.machineModel"
              placeholder="请选择机器型号"
              @change="handleChangeMachineModel"
            >
              <el-option
                v-for="(item, index) in machineListDistinct"
                :key="index"
                :label="item.machineModel + '【' + item.machineName + '】'"
                :value="item.machineModel"
              >
              </el-option>
            </el-select>
          </form>
        </el-form-item>
        <template>
          <el-table
            ref="dataTable"
            :data="quickBindProductTemplates"
            style="width: 90%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55"
              prop="isChecked"
            ></el-table-column>
            <el-table-column prop="hasSet" label="产品ID" width="90">
              <template slot-scope="scope">
                {{
                  scope.row.hasSet
                    ? "【" + scope.row.productid + "】"
                    : "此模板未用"
                }}
              </template></el-table-column
            >
            <el-table-column prop="name" label="产品模板【模板号】" width="180">
              <template slot-scope="scope">
                {{ scope.row.name + "【" + scope.row.templateid + "】" }}
              </template>
            </el-table-column>
            <el-table-column prop="isdisabled" label="禁用" width="">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.isdisabled"></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="isdefault" label="默认" width="">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.isdefault"></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="sequence" label="顺序" width="">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.sequence"
                  placeholder="请输入顺序"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="价格" width="">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.price"
                  placeholder="请输入价格"
                ></el-input>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </template>
      <div class="align-center">
        <el-button type="primary" @click="submitForm()">确定</el-button>
        <el-button @click="closeForm()">关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
// import enumObject from "../../../plugins/enum";
import agentVendorShop from "@/components/layout/agentVendorShop";
//import { mapGetters } from "vuex";
export default {
  components: {
    agentVendorShop
  },
  props: ["editInfo"],
  data() {
    return {
      ruleForm: {
        agentid: "",
        vendorid: "",
        shopid: "",
        agentName: "",
        vendorName: "",
        shopName: "",

        machineModel: "",
        machineModelName: "",
        productTemplateid: "",
        isdefault: false,
        isdisabled: false,
        sequence: 0,
        price: 0
      },
      rules: {
        shopid: [{ required: true, message: "请选择门店" }],
        machineModel: [{ required: true, message: "请选择机器型号" }],
        productTemplateid: [{ required: true, message: "请选择产品模板" }],
        price: [
          { required: true, message: "请输入价格" },
          {
            pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/,
            message: "请输入正确价格"
          }
        ]
      },
      machineList: [],
      machineListDistinct: [],
      productTemplates: [], //产品的模板
      quickBindProductTemplates: [], //融合了 模板数据，和产品数据
      multipleSelection: [],
      selectedAvs: {}
    };
  },
  methods: {
    selectHandler(x) {
      console.log("selectHandler", x);
      this.ruleForm.agentid = x.selectedAgent.agentid;
      this.ruleForm.vendorid = x.selectedVendor.vendorid;
      this.ruleForm.shopid = x.selectedShop.shopid;
      this.getMachine(this.ruleForm.shopid);
      this.ruleForm.machineModel = "";
    },

    initHandler(x) {
      console.log("initHandler", x);
      if (x.selectedAgent && Object.keys(x.selectedAgent).length) {
        this.ruleForm.agentid = x.selectedAgent.agentid;
      }
      if (x.selectedVendor && Object.keys(x.selectedVendor).length) {
        this.ruleForm.vendorid = x.selectedVendor.vendorid;
      }
      if (x.selectedShop && Object.keys(x.selectedShop).length) {
        this.ruleForm.shopid = x.selectedShop.shopid;
      }
      this.getMachine(this.ruleForm.shopid);
    },
    submitForm() {
      // console.log("this.quickBindProductTemplates");
      // console.log(this.quickBindProductTemplates);
      // console.log("this.multipleSelection");
      // console.log(this.multipleSelection);
      if (!this.ruleForm.machineModel) {
        this.$message.error("请选择机器型号!");
        return;
      }
      let needDeleteProductids = [];
      let needUpdateProducts = [];
      let needAddProducts = [];
      let deleteMsg = "确认！该操作将删除产品，编号为：";
      this.quickBindProductTemplates.forEach(x => {
        let tmp = this.multipleSelection.find(y => y.productid == x.productid);
        if (!tmp && x.productid != "") {
          console.log("删除了" + x.productid);
          needDeleteProductids.push(x.productid);
          deleteMsg += "【" + x.productid + "】";
        }
      });

      needUpdateProducts = this.multipleSelection.filter(
        y => y.productid != ""
      );
      needAddProducts = this.multipleSelection.filter(y => y.productid == "");
      console.log("needUpdateProducts");
      console.log(needUpdateProducts);
      console.log("needAddProducts");
      console.log(needAddProducts);
      if (needDeleteProductids.length > 0) {
        this.$confirm(deleteMsg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          console.log("确认删除");
          this.batchSaveProducts(
            needDeleteProductids,
            needUpdateProducts,
            needAddProducts
          );
        });
      } else {
        this.batchSaveProducts(
          needDeleteProductids,
          needUpdateProducts,
          needAddProducts
        );
      }
    },

    batchSaveProducts(
      needDeleteProductids,
      needUpdateProducts,
      needAddProducts
    ) {
      let shopid = this.ruleForm.shopid[this.ruleForm.shopid.length - 1];
      this.$axios(this.$urlMapping["批量设置产品"], {
        data: {
          shopid,
          needDeleteProductids: needDeleteProductids,
          needUpdateProducts: needUpdateProducts,
          needAddProducts: needAddProducts
        }
      }).then(result => {
        console.log(result);
        this.handleChangeMachineModel();
        this.$notifySuccess();
      });
    },

    closeForm() {
      this.$emit("closeForm");
    },
    handleChangeMachineModel() {
      this.productTemplates = [];
      this.ruleForm.productTemplateid = "";
      console.log("this.ruleForm.shopid" + this.ruleForm.shopid);

      if (!this.ruleForm.machineModel || !this.ruleForm.shopid) {
        return;
      }

      //查询产品模板信息，和 产品信息
      //然后融合在一起，赋值给quickBindProductTemplates
      Promise.all([
        this.getProductTemplatesInfo(this.ruleForm.machineModel),
        this.getProductInfo(this.ruleForm.machineModel, this.ruleForm.shopid)
      ]).then(res => {
        console.log("Promise all done");
        console.log(res); //是一个数组，里边的res[index]值就是两个不同的请求返回的结果

        let template = res[0];
        let product = res[1];
        this.quickBindProductTemplates = [];
        template.forEach(x => {
          let j = {};
          j.name = x.name;
          j.templateid = x.productTemplateid;
          j.isdisabled = false;
          j.isdefault = false;
          j.sequence = 0;
          j.price = x.defaultPrice;
          j.hasSet = false;
          j.productid = "";
          j.shopid = this.ruleForm.shopid;
          let p = product.find(ele => ele.templateid == j.templateid);
          if (p) {
            j.price = p.price;
            j.hasSet = true;
            j.productid = p.productid;
            j.sequence = p.sequence;
            j.isdisabled = p.isdisabled;
            j.isdefault = p.isdefault;
          }
          this.quickBindProductTemplates.push(j);
        });
        console.log("this.quickBindProductTemplates");
        console.log(this.quickBindProductTemplates);
        //this.$refs.dataTable.toggleAllSelection();

        //这个设置自动选中的操作，一定要放在$nextTick中，不然无效
        this.$nextTick(() => {
          this.$refs.dataTable.clearSelection();
          //设置过产品的才会给勾上
          this.quickBindProductTemplates.forEach(row => {
            if (row.hasSet) {
              this.$refs.dataTable.toggleRowSelection(row);
            }
          });
        });
      });
    },
    getMachine(machineInShopid) {
      console.log("getMachine", machineInShopid);
      //查询为空的话，直接返回
      if (!machineInShopid) {
        this.machineListDistinct = [];
        return;
      }
      this.$axios(this.$urlMapping["查询机器"], {
        data: {
          machineInShopid
        }
      }).then(result => {
        this.machineList = result.data.map(ele => ele.machineExtendModel);
        let tmplist = [];
        this.machineList.forEach(ele => {
          var x = ele.machineModel + "," + ele.machineName;
          console.log("-----" + x);
          if (tmplist.indexOf(x) >= 0) {
            return;
          }
          tmplist.push(x);
        });

        this.machineListDistinct = tmplist.map(ele => {
          var x = {};
          x.machineModel = ele.split(",")[0];
          x.machineName = ele.split(",")[1];
          return x;
        });

        console.log(this.machineListDistinct);
      });
    },

    getProductTemplatesInfo(machineModel) {
      console.log("1.查询产品模板");
      return this.$axios(this.$urlMapping["查询产品模板"], {
        data: {
          machineModel
        }
      }).then(result => {
        console.log("1.查询产品模板:");
        console.log(result.data);
        this.productTemplates = result.data;
        return result.data;
      });
    },

    getProductInfo(machineModel, shopid) {
      console.log("2.查询模板绑定");
      return this.$axios(this.$urlMapping["查询模板绑定"], {
        data: {
          machineModel,
          shopid
        }
      }).then(result => {
        console.log("2.查询模板绑定:");
        console.log(result);
        return result;
      });
    },

    handleChangeTemplate() {
      let item = this.productTemplates.find(
        ele => ele.productTemplateid === this.ruleForm.productTemplateid
      );
      if (item) {
        this.ruleForm.price = item.defaultPrice;
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    }

    // fillValue() {
    //   console.log("fillvalue");
    //   this.selectedAvs = {
    //     selectedAgentid: this.editInfo.agentid,
    //     selectedVendorid: this.editInfo.vendorid,
    //     selectedShopid: this.editInfo.shopid
    //   };

    //   this.$refs.avs.fillValue(v);
    // }
  },

  mounted() {
    console.log("mounted");

    if (this.editInfo) {
      console.log(this.editInfo);

      //this.ruleForm.shopid = ["a1155", "v1336", "s1337"];
      this.ruleForm.shopid = this.editInfo.shopid;
      this.ruleForm.vendorid = this.editInfo.vendorid;
      this.ruleForm.agentid = this.editInfo.agentid;

      this.ruleForm.shopName = this.$getShopName(this.editInfo.shopid);
      this.ruleForm.vendorName = this.$getVendorName(this.editInfo.vendorid);
      this.ruleForm.agentName = this.$getAgentName(this.editInfo.agentid);

      this.selectedAvs = {
        selectedAgentid: this.editInfo.agentid,
        selectedVendorid: this.editInfo.vendorid,
        selectedShopid: this.editInfo.shopid
      };
      //this.handleChange(this.ruleForm.shopid);
      this.ruleForm.machineModel = this.editInfo.machineModel;
      this.handleChangeMachineModel();
    }
  }
};
</script>

<style lang="less" scoped></style>
